const smartlookFn = () => (window ? window['smartlook'] : undefined);

export const smartLookInit = () => {
  if (!smartlookFn()) {
    const script = document.createElement('script');

    script.innerHTML = `
      window.smartlook||(function(d) {
        var o=smartlook=function(){ o.api.push(arguments)},h=d.getElementsByTagName('head')[0];
        var c=d.createElement('script');o.api=new Array();c.async=true;c.type='text/javascript';
        c.charset='utf-8';c.src='https://rec.smartlook.com/recorder.js';h.appendChild(c);
        })(document);
        smartlook('init', '2e11a13cdbdbd3041b6cc63ce647b851591b6a8e');
    `;

    document.body.appendChild(script);
  }
};

export const smartlookConsent = () => {
  const smartLook = smartlookFn();
  const consentMsg = 'Here go consent text';
  if (smartLook) {
    smartLook('consentForms', consentMsg);
    smartLook('consentIP', consentMsg);
    smartLook('consentAPI', consentMsg);
  }
};

export const smartlookIdentify = (userId: string, args: Object) => {
  const smartLook = smartlookFn();
  if (smartLook) {
    smartLook('identify', userId, args);
  }
};

export const smartlookError = error => {
  const smartLook = smartlookFn();

  if (smartLook) {
    smartLook('error', error);
  }
};
